import { Component, OnDestroy, OnInit } from "@angular/core";
import { AuthenticationManager } from "../../authentication";
import { forkJoin, Subscription, catchError, of } from "rxjs";
import { UserAttributes } from "../../shared/models/user-attributes";
import { NavigationService } from "../../shared";
import { UnitsManager } from "../../units/services/units-manager";
import { InstallationsManager } from "../../installations/services/installations-manager";
import { PbxManager } from "../../pbx/services/pbx-manager";
import { Unit } from "../../shared/models/units/unit";
import { Installation } from "../../shared/models/installations/installation";
import { Pbx } from "../../pbx/models/pbx";

@Component({
  selector: "app-general-sidebar",
  templateUrl: "./general-sidebar.component.html",
  styleUrl: "./general-sidebar.component.scss",
})
export class GeneralSidebarComponent implements OnInit, OnDestroy {
  private _userLoggedInSubscription: Subscription | null = null;
  private _userAttributesSubscription: Subscription | null = null;

  currentUserAttributes: UserAttributes | null = null;
  units: Unit[] = [];
  installations: Installation[] = [];
  pbxs: Pbx[] = [];

  constructor(
    private auth: AuthenticationManager,
    private navigation: NavigationService,
    private unitsManager: UnitsManager,
    private installationsManager: InstallationsManager,
    private pbxManager: PbxManager
  ) {}

  ngOnInit(): void {
    this.listenUserLoginUpdates();
    this.listenUserAttributesUpdates();
  }

  ngOnDestroy(): void {
    this._userLoggedInSubscription?.unsubscribe();
    this._userAttributesSubscription?.unsubscribe();
  }

  openHomepage = () => this.navigation.navigateToInstallationsList();

  openAppInfo = () => this.navigation.navigateTo("application/info");

  openUnit(unit: Unit) {
    this.navigation.navigateToUnitDashboard(unit.installation_id, unit.id);
  }

  openInstallation(installation: Installation) {
    this.navigation.navigateToInstallationDetail(installation.id);
  }

  openPbx(pbx: Pbx) {
    this.navigation.navigateToPbxDashboard(pbx.installation_id, pbx.id);
  }

  private loadNavigationData() {
    forkJoin({
      units: this.unitsManager.getUnits().pipe(catchError(() => of([]))),
      installations: this.installationsManager.getInstallations().pipe(catchError(() => of([]))),
      pbxs: this.pbxManager.getPbxs().pipe(catchError(() => of([])))
    }).subscribe(({ units, installations, pbxs }) => {
      this.units = units;
      this.installations = installations;
      this.pbxs = pbxs;
    });
  }

  private loadCurrentUserAttributes() {
    this.auth.currentUserAttributes().subscribe({
      next: (attributes) => (this.currentUserAttributes = attributes),
    });
  }

  private listenUserLoginUpdates() {
    this._userLoggedInSubscription = this.auth
      .userLoggedInUpdates()
      .subscribe((loggedIn) => {
        if (loggedIn) {
          this.loadCurrentUserAttributes();
          this.loadNavigationData();
        }
      });
  }

  private listenUserAttributesUpdates() {
    this._userAttributesSubscription = this.auth
      .userAttributesUpdates()
      .subscribe((attributes: UserAttributes | null) => {
        if (attributes) {
          this.currentUserAttributes = attributes;
        }
      });
  }
}
